import React, {Component} from 'react';

export class Activity extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { created, updated, deleted, row } = this.props;
        return (
            <div className="activity-container">
                <a className="activity-btn"><i className="las la-user"></i></a>
                <div className="activity-content">
                    { row.createdBy && created && created.username ? <div><span className="m-badge m-badge--success mx-auto my-0 px-2" style={{marginBottom: '20px !important'}}><strong>Created By</strong> <br/>{created.username} </span></div> : ""}     
                    { row.updatedBy && updated && updated.username ? <div style={{marginTop: 10}}>&nbsp;<span className="m-badge m-badge--warning mx-auto my-0 px-2" style={{marginTop: '20px !important'}}><strong>Updated By</strong> <br/>{updated.username}</span></div> : ""}     
                    { row.deletdBy && deleted && deleted.username ? <div>&nbsp;<span className="m-badge m-badge--danger mx-auto my-0 px-2" style={{marginBottom: '20px !important'}}><strong>Deleted By</strong> <br/>{deleted.username}</span></div> : ""}
                    { !row.createdBy && !row.updatedBy ? <div>&nbsp;<span style={{marginBottom: '20px !important', fontSize: "10px", color: "#FFF"}}>Data Not Available</span></div> : ""}
                </div>
            </div>
        )
    }
}


  